import { TParticipant, TUser } from '../../configuration/common.types';

export function getParticipantsNames(
    currentUser: Partial<TUser>,
    participants: TParticipant[] | undefined
) {
    if (!participants) {
        return '';
    }
    const filteredParticipants = participants.filter(
        participant => participant.userId !== currentUser.id
    );

    const participantsNames =
        filteredParticipants
            .map(
                participant => `${participant.forename} ${participant.surname}`
            )
            .join(', ') || '';

    return participantsNames;
}
